import { testimonials } from "@/mocks/comics";

export default function About() {
  return (
    <section id="about" className="w-full bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-700">
              <i className="ri-seedling-line"></i> 关于我们
            </span>
            <h2 className="mt-3 font-heading text-2xl leading-snug text-foreground-950 md:text-4xl">
              把每天的快乐，做成一本会说话的漫画杂志
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              韩国歪歪漫画致力于收集生活中最真实、最离谱、最好笑的那一面。
              我们相信，一个有趣的段子、一张犀利的梗图，就足以点亮平淡的一天。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              从沙雕日常到神吐槽，从梗图段子到无厘头剧场，我们坚持内容真实、
              更新持续、体验轻松。无论是通勤摸鱼还是睡前刷一刷，这里都是你放松心情的好去处。
            </p>
            <ul className="mt-6 space-y-3">
              {[
                { icon: "ri-heart-3-line", text: "坚持轻松真实，用笑点连接每一位乐子人" },
                { icon: "ri-refresh-line", text: "内容持续更新，打开即看零门槛" },
                { icon: "ri-user-smile-line", text: "尊重每一位读者，评论区随时欢迎整活" },
              ].map((it) => (
                <li key={it.text} className="flex items-center gap-3 text-sm text-foreground-700">
                  <span className="grid h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-lg text-primary-600">
                    <i className={it.icon}></i>
                  </span>
                  {it.text}
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-4">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="rounded-2xl border border-background-200 bg-background-50 p-5"
              >
                <div className="flex items-center gap-1 text-secondary-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`${i < t.star ? "ri-star-fill" : "ri-star-line"} text-sm`}
                    ></i>
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="grid h-10 w-10 items-center justify-center rounded-full bg-accent-100 font-heading text-primary-700">
                    {t.name.slice(0, 1)}
                  </span>
                  <div>
                    <div className="text-sm font-medium text-foreground-900">{t.name}</div>
                    <div className="text-xs text-foreground-500">{t.role}</div>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}